import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { history } from '../helpers/history';
import Header from '../Header/Header';
import Barcode from 'react-barcode';
import { gameActions } from '../action/GameAction';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ReactToPrint from "react-to-print";
import { commonClass } from "../helpers/commonClass";
import { Helmet } from 'react-helmet';
import Footer from '../Footer/Footer';
import HomeSlidTabs from './Home/HomeSlidTabs';
class PaymentStatusNew extends Component {
    constructor(props) {
        super(props);
        //only allow logged in users
        if (!props.user || props.user.mobileNo == "0") {
            history.push('/login');
        }
        // props.ClearCart();
    }
    componentDidMount() {
        if (localStorage.getItem('sendEventFlog') == 1 && this.props.myBet) {
            localStorage.removeItem('sendEventFlog');
            localStorage.removeItem('ftimesel');
            let myBet = this.props.myBet;
            if (myBet.status == 0) {
                let uObj = {}
                commonClass.SendEventTracking(15, uObj, false, myBet.betLst);
                commonClass.SendOtherEvent(3, 1, myBet);
                commonClass.SendPageDataLayer(12);
                myBet.ggourArr && myBet.ggourArr.forEach(ggID => {
                    if (ggID == 1) {
                        commonClass.SendPageDataLayer(14);
                    }
                    if (ggID == 3) {
                        commonClass.SendPageDataLayer(16);
                    }
                    else if (ggID == 2) {
                        commonClass.SendPageDataLayer(15);
                    }
                    else if (ggID == 4) {
                        commonClass.SendPageDataLayer(18);
                    }
                    else if (ggID == 5) {
                        commonClass.SendPageDataLayer(21);
                    }
                    else if (ggID == 6) {
                        commonClass.SendPageDataLayer(23);
                    }
                })
            }
            else {
                let uObj = {
                    'REASON': myBet?.msg
                }
                commonClass.SendEventTracking(19, uObj);
                commonClass.SendPageDataLayer(13);
            }
        }
    }

    gotoHome = () => {
        history.push('/home');
    }
    // downloadPdfDocument = (downloadFileName) => {
    //     let downID = "qwinprint1";
    //     let downDivID = "qwinprint";
    //     document.getElementById(downID).style.maxHeight = "none"
    //     let input = document.getElementById(downDivID);
    //     html2canvas(input)
    //         .then((canvas) => {
    //             let imgData = canvas.toDataURL('image/png');
    //             let pdf = new jsPDF();
    //             pdf.addImage(imgData, 'JPEG', 20, 0);
    //             pdf.save(`${downloadFileName}.pdf`);
    //         })
    //     document.getElementById(downID).style.removeProperty("max-height")
    // }

    // getPrintCont = () => {
    //     let downID = "qwinprint1";
    //     let downDivID = "qwinprint";
    //     document.getElementById(downID).style.maxHeight = "none"
    //     let input = document.getElementById(downDivID).cloneNode(true);
    //     document.getElementById(downID).style.removeProperty("max-height");
    //     return input;
    // }
    downloadPdfDocument = (downloadFileName, val) => {
        let downID = "qwinprint1";
        let downDivID = "qwinprint" + '' + val;
        document.querySelectorAll("#" + downID).forEach(element => {
            element.style.maxHeight = "none";
        });
        let input = document.getElementById(downDivID);
        html2canvas(input, {
            scale: 3,
            useCORS: true,
            allowTaint: true,
            scrollY: -window.scrollY,
            width: input.scrollWidth,
        }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            // let pdf = new jsPDF('p', 'pt', [1800, 700]);
            //pdf.addImage(imgData, 'JPEG', 30, 60);
            let pdf = new jsPDF("p", "mm", "a4");
            var width = pdf.internal.pageSize.getWidth();
            var height = (pdf.internal.pageSize.getHeight());
            pdf.addImage(imgData, 'JPEG', 3, 3, 200, input.offsetHeight * 0.4); //width*0.90, height*0.50
            pdf.save(`${downloadFileName}.pdf`);
        })
        document.querySelectorAll("#" + downID).forEach(element => {
            element.style.removeProperty("max-height");
        });
    }
    getPrintCont = (val) => {
        let downID = "qwinprint1";
        let downDivID = "qwinprint" + '' + val;
        document.querySelectorAll("#" + downID).forEach(element => {
            element.style.maxHeight = "none";
        });
        let input = document.getElementById(downDivID).cloneNode(true);
        document.querySelectorAll("#" + downID).forEach(element => {
            element.style.removeProperty("max-height");
        });
        input.style.marginTop = "50px";
        input.style.paddingLeft = "50px";
        input.style.paddingRight = "50px";
        input.style.display = "block";
        input.style.visibility = "visible";
        input.style.overflow = "visible";
        input.style.boxSizing = "border-box";
        input.querySelectorAll("*").forEach(child => {
            child.style.maxHeight = "none";
            child.style.display = "block";
            child.style.visibility = "visible";
            child.style.overflow = "visible";

        });
        return input;
    }

    gotoTryAgain = (id) => {
        if (id == 3) {
            history.push('/payment');
        }
        else {
            this.gotoHome();
        }
    }

    render() {
        const { t } = this.props;
        let gamegroupLst = (this.props.myBet && this.props.myBet.betLst) ? [...new Set(this.props.myBet.betLst.map(item => item.GameID))] : [];
        let flst = [];
        let _transID = "";
        let _gameID = "";
        let _gameTime = "";
        function dd(Id, GameTime, GameID) {
            _transID = Id;
            _gameTime = GameTime;
            _gameID = GameID;
        }
        function tfilte(betLst) {
            flst = [...new Set(betLst.map(item => item.GameID))]
        }
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : PaymentStatus</title>
                    <meta name="description" content="Gulf Ticket PaymentStatus" />
                </Helmet>
                }
                <Header />
                <div class="container">
                    <HomeSlidTabs />
                    {this.props.myBet.status != 0 &&
                        <div class="subContainer">
                            <div class="pasContainer2">
                                <span class="checkImg"><img src="./assets/img/icons/failed.png" /></span>
                                <h3>{t('lblPaymentFailed')}</h3>
                                <small>{this.props.myBet.msg}
                                    <br />{t('lblThankChooseGulfTicket')}</small>
                                <div>
                                    <a onClick={() => { this.gotoTryAgain(this.props.myBet.status) }} id="tryAgain">{t('lblTryAgain')}</a>
                                    <a onClick={() => { history.push('/') }}>{t('lblBactToHome')}</a>
                                </div>
                            </div>
                        </div >
                    }
                    {
                        this.props.myBet.status == 0 &&
                        <div class="content2">
                            <div class="paymentContain">
                                <div class="paymentSuccess">
                                    <div class="paymentSuccCont">
                                        <div class="paymentSuccContLft">
                                            <div class="paySuccContLftInr">
                                                {this.props.myBet && this.props.myBet.status != 0 && <h1 className="paySuccContLftInr">{t('lblPaymentFailed')}</h1>}
                                                {this.props.myBet && this.props.myBet.status == 0 && <h1 className="paySuccContLftInr">{t('lblPaymentSucc')}</h1>}
                                                {
                                                    this.props.myBet && this.props.myBet.status == 0 ?
                                                        <>
                                                            <img src="./assets/img/icons/success.png" />
                                                            <h3>{t('lblCongratss')}</h3>
                                                            <span>{t('lblCongrats')}</span>
                                                            <div class="paymentRecived">
                                                                <img src="./assets/img/icons/green-tick.png" />
                                                                <span>{this.props.myBet.msg}</span>
                                                            </div>
                                                            <button onClick={() => { history.push('/') }}>{t('lblBactToHome')}</button> </>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                        </div>
                                        <div class="paymentSuccContRht">
                                            {this.props.myBet && this.props.myBet.status == 0 &&
                                                <>
                                                    {gamegroupLst && gamegroupLst.map((x1, incx) =>
                                                        <>
                                                            <div className="paySuccContRhtInr ">
                                                                <div className="paySuccTicket no-scrollbar" id={`qwinprint${incx + 1}`}>
                                                                    {dd(this.props.myBet.betLst.filter(a => a.GameID == x1)[0].Id, this.props.myBet.betLst.filter(a => a.GameID == x1)[0].GameTime, this.props.myBet.betLst.filter(a => a.GameID == x1)[0].GameID)}
                                                                    <div class="paySuccTicketTop">
                                                                        <img class="ticketLogo" src="./assets/img/logo.png" />
                                                                        <h5>{t('lblTicketDet')}</h5>
                                                                        <p><span>{t('lblTransId')}: </span><span>{_transID}</span></p>
                                                                    </div>
                                                                    {tfilte(this.props.myBet.betLst.filter(a => a.GameID == x1))}
                                                                    <div class="paySuccTicketBallCont">
                                                                        <div class={`paySuccTicketBallLi lto-${this.props.myBet.betLst.filter(a => a.GameID == x1)[0].gamegroupID}-bg-gradiant`}>
                                                                            {this.props.myBet.betLst.filter(a => a.GameID == x1).filter(a => a.GameID == x1).map((x, idx) =>
                                                                                <>
                                                                                    <div class="paySucTiktGaName">
                                                                                        <span>{x.GameName}</span><p>{t('lblTicket')} #{idx + 1}</p>
                                                                                    </div>
                                                                                    <div class="paySucTiktBalls">
                                                                                        <ul>
                                                                                            {x.BallNo.split(';').map((x2, idx2) => <li><div> {x2}</div></li>)}
                                                                                        </ul>
                                                                                    </div>
                                                                                    {/* <div class="paySucTiktRafleId">
                                                                                {t('lblRafflaID')}: {x.RaffleID}
                                                                                </div> */}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div >
                                                                    <div class="ticketDetails">
                                                                        <ul>
                                                                            <li>
                                                                                <div>{t('lblPlays')}:</div>
                                                                                <div>{this.props.myBet.betLst.filter(a => a.GameID == x1).length}</div>
                                                                            </li>
                                                                            <li>
                                                                                <div>{t('lblSubmitted')}:</div>
                                                                                <div>{this.props.myBet.betLst.filter(a => a.GameID == x1)[0].TransDateTime}</div>
                                                                            </li>
                                                                            <li>
                                                                                <div>{t('lblTicketId')}:</div>
                                                                                <div>{_transID}</div>
                                                                            </li>
                                                                            <li>
                                                                                <div>{t('lblTotalSpend')}:</div>
                                                                                <div>{process.env.REACT_APP_CURRENCY} {this.props.myBet.betLst.filter(a => a.GameID == x1).reduce((a, b) => a = a + b.StakeValue, 0)}</div>
                                                                            </li>
                                                                            <li>
                                                                                <div>{t('lblModeOfPay')}:</div>
                                                                                <div>{this.props.myBet.payment_mode}</div>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <Barcode displayValue="true" height="50px" format="CODE128" value={_transID} />
                                                                </div >
                                                                <div className="printSec">
                                                                    <button onClick={() => { this.downloadPdfDocument(this.props.myBet.betLst.find(a => a.GameID == x1).Id, incx + 1) }}><img src="./assets/img/icons/drive.png" alt='inbox_download icon' /></button>
                                                                    <button><ReactToPrint
                                                                        trigger={() => <a><img src="./assets/img/icons/print.png" alt='printer icon' /></a>}
                                                                        content={() => this.getPrintCont(incx + 1)}
                                                                    /></button>
                                                                </div>
                                                            </div >
                                                        </>
                                                    )}



                                                </>
                                            }
                                            {this.props.myBet && this.props.myBet.status != 0 && <>
                                                <div className="lightbox21" style={{ display: "block" }}>
                                                    <div className="newCo">

                                                    </div>
                                                </div>
                                            </>
                                            }

                                        </div>
                                    </div >
                                </div>
                            </div >
                        </div >
                    }
                </div>
                <Footer />
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { myBet } = state.gameReducer;
    return { user, myBet, appvariables };
}
const mapActionToProps = {
    ClearCart: gameActions.ClearCart,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(PaymentStatusNew))